/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beitragsgruppenschluesselpv2Inputs */



/**

* @param {_Field_Beitragsgruppenschluesselpv2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beitragsgruppenschluesselpv2 = /** @type {((inputs?: _Field_Beitragsgruppenschluesselpv2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beitragsgruppenschluesselpv2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beitragsgruppenschlüssel PV")
});
export { _field_beitragsgruppenschluesselpv2 as "_field_beitragsgruppenschluesselPV" }